module.exports = __webpack_public_path__ + "static/media/greenChip.5b56be9f.svg";